import styled from "styled-components";
// import { Link as LinkS } from "react-scroll";
import { Link as LinkS } from "react-router-dom";

import { X } from "phosphor-react";

export const SidebarContainer = styled.aside`
	position: fixed;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: var(--white);
	display: grid;
	align-items: center;
	top: 0;
	left: 0;
	transition: 0.5s ease-in-out;
	opacity: ${({ isOpen }) => (isOpen ? "100" : "0")};
	top: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
`;

export const Icon = styled.div`
	position: absolute;
	top: 1.2rem;
	background: transparent;
	cursor: pointer;
	outline: none;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const CloseIcon = styled(X)`
	color: black;
	width: 35px;
	height: 35px;
	display: block;
	margin-right: 50px;
`;

export const NavLogoImg = styled.img`
	width: 100px;
	height: 100px;
`;

export const SidebarWrapper = styled.div`
	color: #fff;
`;

export const SidebarMenu = styled.ul`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: repeat(3, 100px);
	text-align: center;

	@media screen and (max-width: 480px) {
		grid-template-rows: repeat(3, 60px);
	}
`;

export const SidebarLink = styled(LinkS)`
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	list-style: none;
	transition: 0.2 ease-in-out;
	color: var(--darkGrey);
	cursor: pointer;
`;
